import { useEffect } from 'react';
import { getPermalink } from '@medifind/interface';
import { changeURLParams } from '@medifind/router';
import { useRouter } from '@medifind/router';
import { isPrerender } from '@medifind/utils';
import { setFilterValue } from '@medifind/zustand';

export const usePermalinkLoader = ({ onLoad, preLoad, filterList = [] }) => {
  const router = useRouter();
  const { permalink } = router.query;

  useEffect(() => {
    const load = async () => {
      if (permalink) {
        const permaLinkData = (await getPermalink(permalink).catch(() => ({}))).data;
        if (permaLinkData) {
          if (preLoad) preLoad({ data: permaLinkData });
          const { filters = [] } = permaLinkData;
          filterList.forEach((f) => f.getState().reset());
          filters
            .filter(({ selected }) => selected)
            .forEach((filterData) => {
              // check to see if filter is saved as a redux action
              const { selected } = filterData;
              const filter = filterList.find((store) => store.getState().name === filterData.name);
              if (filter) setFilterValue(filter, selected);
            });

          let urlParams = {};
          if (onLoad) urlParams = onLoad({ data: permaLinkData }) || {};

          if (!isPrerender) changeURLParams(router, { permalink: null, ...urlParams }, { type: 'replace' });
        }
      }
    };
    load();
  }, [permalink]);
  return null;
};
